/**
 * @name HomeExternal
 * @description Componente del dashboard home para usuarios externos
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';

import { Layout, Typography } from '@styles';

const HomeExternal = () => {
  return (
    <>
      <Layout.Title>
        <Typography.H3>{i18n.t('GenericMessages.welcome')}</Typography.H3>
      </Layout.Title>

      <Layout.Content>
        <Typography.H6>{i18n.t('Home.youExternalUser')}</Typography.H6>
      </Layout.Content>
    </>
  );
};

export default HomeExternal;